import _ from "lodash";
import { useTranslation } from "react-i18next";
import { Box, Stack, Tooltip, Typography, useTheme } from "@mui/material";
import Icon from "../../../../Icon/Icon";
import { EGInput } from "../../../../MainComponents/Input/EGInput";

export const CommentFiles = ({
  files,
  setFiles,
  pathName = "name",
  pathSize = "size",
}) => {
  const [t] = useTranslation("report");
  const theme = useTheme();

  const handleCommentary = (e, idx) => {
    const { value } = e.target;
    const newFiles = _.cloneDeep(files);
    newFiles[idx].comment = value;
    setFiles(newFiles);
  };

  const handleDeleteFile = (idx) => {
    const newFiles = _.cloneDeep(files);
    newFiles.splice(idx, 1);
    setFiles(newFiles);
  };

  return (
    <>
      {files.map((item, idx) => (
        <div key={idx}>
          <Box key={idx} position="relative" paddingX={4.4} paddingY={1}>
            <Icon
              name="paperclip_2"
              size={20}
              color="#FFF"
              style={{
                backgroundColor: "teal",
                padding: 3,
                borderRadius: "50%",
                position: "absolute",
                top: 10,
                left: 10,
              }}
            />
            <Box
              onClick={() => handleDeleteFile(idx)}
              style={{
                position: "absolute",
                top: 10,
                right: 10,
                cursor: "pointer",
              }}
            >
              <Tooltip title={t("Conclusion.delete")} placement="bottom" arrow>
                <Box>
                  <Icon
                    name="trash_can"
                    size={16}
                    color={theme.palette.red.main}
                  />
                </Box>
              </Tooltip>
            </Box>
            <Stack>
              <Typography marginBottom={1.6} fontSize={16}>
                {_.get(item, pathName) || "No name"}{" "}
                {_.get(item, pathSize) ? `(${_.get(item, pathSize)}) kb` : ""}
              </Typography>
              <EGInput
                label={t("Conclusion.file_comments")}
                placeholder={t("Conclusion.file_comments_placeholder")}
                rows={4}
                multiline
                value={item.comment ? item.comment : ""}
                onChange={(e) => handleCommentary(e, idx)}
              />
            </Stack>
          </Box>
        </div>
      ))}
    </>
  );
};
